import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/rows.css'
import './styles/stories.css'
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query'; 
import { AuthProvider } from 'context/AuthContext';
import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
  {/* <React.StrictMode> */}  
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  {/* </React.StrictMode> */}
 </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
